import React from 'react'

import { F0Card } from '@factorialco/f0-react'

export interface ManageDevicesFeatureProps {
  title?: string | null
  description?: string | null
  emoji?: string | null
}

export const ManageDevicesFeature: React.FC<ManageDevicesFeatureProps> = ({
  title,
  description,
  emoji,
}) => {
  return (
    <F0Card
      avatar={{
        type: 'emoji',
        emoji: emoji || '',
      }}
      title={title || ''}
      description={description || ''}
    />
  )
}
